import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ActivatedRoute,
  Params,
  Router
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilsService } from './core/services/utils.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { PairingStepFormApi } from 'src/app/core/components/pairing-step-form/pairing-step-form.service';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})


export class AppComponent implements OnInit {
  flag: any = 'false';
  errFlag: any = 'false';
  tempFlag: any;
  errM: string = null;
  isShow: boolean = false;
  typeSelected: string;
  getBoolean: any;
  subscription: Subscription;
  token: any;
  isAdmin: boolean = false;
  error: string;
  urlString: string;
  parentToken: any;

  constructor(
    private readonly http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private readonly spinnerService: NgxSpinnerService,
    private readonly utilService: UtilsService,
    private readonly router: Router,
    private readonly location: Location,
    private readonly auth: AuthService,
    private readonly pairingStepFormApi: PairingStepFormApi
  ) {
    this.urlString = window.location.href;
    this.spinnerService.show();
    this.typeSelected = 'ball-clip-rotate-pulse';

    // Preserve the original URL before Auth0 may redirect to its login page.
    // The Auth0 callback URL (?code=&state=) loses the original route, so we
    // store it here and restore it after the user profile has been loaded.
    const isAuthCallback = this.urlString.includes('code=') && this.urlString.includes('state=');
    if (!isAuthCallback && !sessionStorage.getItem('originalUrl')) {
      const path = new URL(this.urlString).pathname;
      if (path !== '/' && path !== '/home') {
        sessionStorage.setItem('originalUrl', this.urlString);
      }
    }

    this.auth.getAccessTokenSilently().subscribe((res: any) => {
      localStorage.setItem('token', res);
      if (!sessionStorage.getItem('jwtToken')) {
        //  sessionStorage.clear();
        sessionStorage.setItem('jwtToken', localStorage.getItem('token'));
      }
      this.getBoolean = false;
    });
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const token = params.token;
      if (token !== undefined) {
        sessionStorage.setItem('parentToken', token);
      }
    });

    if (this.urlString.indexOf('token') != -1) {
      if (!sessionStorage.getItem('parentToken')) {
        sessionStorage.setItem('parentToken', this.urlString?.split("token=")[1]);
      }
      if (this.urlString?.split("/").length > 4) {
        let reqIdStr = this.urlString?.split("/")[4];
        let reqId = reqIdStr?.split("?")[0];
        //let token = reqId.concat('~').concat(reqIdStr?.split("?")[1]);
        sessionStorage.setItem('parentToken', reqIdStr?.split("=")[1]);
        this.checkURL(reqId);
      } else {
        this.cleanURL();
      }

    } else if (this.urlString.indexOf('pairingAsProduct/') == -1) {
      this.cleanURL();
    } else {
      let reqIdStr = this.urlString?.split("/")[4];
      this.checkURL(reqIdStr);
    }

    //this.cleanURL(urlString.split("/")?.[1], reqId[0]);

    if (sessionStorage.getItem('userRole')) {
      return;
    } else {
      this.auth.user$.subscribe((user) => {
        sessionStorage.setItem('id', user?.sub);
        return this.pairingStepFormApi.getUser().subscribe((res: any) => {
          const id = res.result.userId;
          const userRole = res.result.userRole;
          sessionStorage.setItem('userRole', userRole);
          sessionStorage.setItem('userId', id);
          this.utilService.userId(id);
          this.error = '';
          this.navigateAfterAuth();
        },

          (err: any) => {
            this.spinnerService.hide();
            if (this.errM !== null || this.errM !== undefined || this.errM) {
              if (err.status == 401 || err.status == 403) {
                this.error =
                  'Authentication Failed! due to some technical error, Please try to relogin.';
              } else if (err.status.startsWith('5')) {
                this.error =
                  'Service unavailable due to Internal Server Error.';
              }
            }
          });
      });
    }

    this.utilService.showPopup.subscribe((res: any) => {
      this.spinnerService.hide();
      this.getBoolean = res;
    });

    this.spinnerService.show();
    this.utilService.SharingData.subscribe((res: any) => {
      this.spinnerService.hide();
      this.errM = res;
    });
  }

  private navigateAfterAuth(): void {
    const targetUrl = sessionStorage.getItem('originalUrl') || this.urlString;
    sessionStorage.removeItem('originalUrl');

    if (targetUrl.indexOf('jobrequest') !== -1) {
      const reqId = targetUrl.split('/')[4]?.split('?')[0];
      this.router.navigate(['/pairingAsProduct/edit/', reqId]).then(() => window.location.reload());
    } else if (targetUrl.indexOf('copyrequest') !== -1) {
      const reqId = targetUrl.split('/')[4]?.split('?')[0];
      this.router.navigate(['/pairingAsProduct/copy/', reqId]).then(() => window.location.reload());
    } else if (targetUrl.indexOf('pairingAsProduct') !== -1) {
      this.router.navigate(['/pairingAsProduct']).then(() => window.location.reload());
    } else if (targetUrl.indexOf('admin') !== -1) {
      this.router.navigate(['/admin']).then(() => window.location.reload());
    } else if (targetUrl.indexOf('insights') !== -1) {
      this.router.navigate(['/insights']).then(() => window.location.reload());
    } else {
      this.router.navigate(['/home']).then(() => window.location.reload());
    }
  }

  checkURL(reqId: any) {
    if (this.urlString.indexOf('jobrequest') != -1) {
      this.router.navigate(['/pairingAsProduct/edit/', reqId]).then(() => window.location.reload());
    } else if (this.urlString.indexOf('copyrequest') != -1) {
      this.router.navigate(['/pairingAsProduct/copy/', reqId]).then(() => window.location.reload());
    }
  }

  cleanURL() {
    if (this.urlString.indexOf('home') != -1) {
      this.location.replaceState('home');
    } else if (this.urlString.indexOf('pairingAsProduct') != -1) {
      this.location.replaceState('pairingAsProduct');
    } else if (this.urlString.indexOf('admin') != -1) {
      this.location.replaceState('admin');
    }
  }


}
